// extracted by mini-css-extract-plugin
export var productList = "styles_productList__A9goc";
export var shipment = "styles_shipment__KjDpA";